import { render } from "./CreateDriverModal.vue?vue&type=template&id=28592682&ts=true"
import script from "./CreateDriverModal.vue?vue&type=script&lang=ts"
export * from "./CreateDriverModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__